import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { Bundle, Package } from '@/@types/graphql-types';
import { useI18n } from '@/helpers/composables/useI18n';
import CheckboxInput from '@/ui-components/CheckboxInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PackageRow',
  props: {
    packageItem: null,
    showBadge: { type: Boolean, default: true },
    showDivider: { type: Boolean, default: true }
  },
  emits: ["onPackageToggle"],
  setup(__props: any) {

const props = __props as { packageItem: Package | Bundle, showBadge: boolean, showDivider: boolean };





const { t } = useI18n();

const badgeLabel = computed(() => {
	if (props.packageItem.__typename === 'Package') {
		const { bundles = [], addons = [] } = props.packageItem;
		if (bundles.length > 0 || addons.length > 0) {
			return t('WEBAPP_PACKAGES_EXTRAS');
		}
	}
	return null;
});

const isBadgeActive = computed(() => {
	if (props.packageItem.__typename === 'Package') {
		const shouldBeActive = props.packageItem.selected;
		const hasActiveBundles = props.packageItem.bundles.some(b => b.selected);
		const hasSelectedAddons = props.packageItem.addons.some(a => a.selected);
		return shouldBeActive && (hasActiveBundles || hasSelectedAddons);
	}
	return false;
});

const providerShortName = computed(() => {
	if (props.packageItem.__typename === 'Package') {
		return props.packageItem.shortName;
	} else {
		return props.packageItem.shortName;
	}
});

return { __sfc: true,props, t, badgeLabel, isBadgeActive, providerShortName, ProviderIcon, CheckboxInput }
}

})